import { FormPropertyFactory, PropertyGroup, FormProperty, SchemaValidatorFactory, ValidatorRegistry } from "./angular2-schema-form-shim";
import { NumberProperty, StringProperty, BooleanProperty, ObjectProperty, ArrayProperty } from "./formproperty";

export function useFactory( schemaValidatorFactory: SchemaValidatorFactory, validatorRegistry: ValidatorRegistry ) {
  return new SPFormPropertyFactory( schemaValidatorFactory, validatorRegistry );
}

export class SPFormPropertyFactory extends FormPropertyFactory {

  createProperty(schema: any, parent: PropertyGroup = null, propertyId?: string): FormProperty {
    let newProperty = null;
    let path = '';
    if (parent) {
      path += parent.path;
      if (parent.parent !== null) {
        path += '/';
      }
      if (parent.type === 'object') {
        path += propertyId;
      } else if (parent.type === 'array') {
        path += '*';
      } else {
        throw 'Instanciation of a FormProperty with an unknown parent type: ' + parent.type;
      }
    } else {
      path = '/';
    }

    if (schema.$ref) {
      const refSchema = this.schemaValidatorFactory.getSchema(parent.root.schema, schema.$ref);
      newProperty = this.createProperty(refSchema, parent, path);
    } else {
      const effectiveType = Array.isArray(schema.type)
        ? schema.type.find(t => t !== 'null') || schema.type[0]
        : schema.type;

      switch (effectiveType) {
        case 'integer':
        case 'number':
          newProperty = new NumberProperty(this.schemaValidatorFactory, this.validatorRegistry, schema, parent, path);
          break;
        case 'string':
          newProperty = new StringProperty(this.schemaValidatorFactory, this.validatorRegistry, schema, parent, path);
          break;
        case 'boolean':
          newProperty = new BooleanProperty(this.schemaValidatorFactory, this.validatorRegistry, schema, parent, path);
          break;
        case 'object':
          newProperty = new ObjectProperty(this, this.schemaValidatorFactory, this.validatorRegistry, schema, parent, path);
          break;
        case 'array':
          newProperty = new ArrayProperty(this, this.schemaValidatorFactory, this.validatorRegistry, schema, parent, path);
          break;
        default:
          throw new TypeError(`Undefined type ${schema.type}`);
      }
    }

    if (newProperty instanceof PropertyGroup) {
      this.initializeRoot(newProperty);
    }

    return newProperty;
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/formpropertyfactory.ts